export default class Product {
  constructor({ name, isRecommended = false, usage = null, size }) {
    this.name = name;
    this.isRecommended = isRecommended;
    this.usage = usage;
    this.size = size;
  }
}
